"use strict";

var _writer = require("./writer");

var _reader = require("./reader");

var _share = require("./share");

module.exports = {
  parsePngFormat: _reader.parsePngFormat,
  writePngDpi: _writer.writePngDpi,
  convertToDataURI: _share.convertToDataURI,
  convertToByteArray: _share.convertToByteArray
};